// ZAVELLE — Theme JS

// ── Cart ─────────────────────────────────────────────
function openCart() {
  document.getElementById('cart-drawer').classList.add('open');
  document.getElementById('cart-drawer').setAttribute('aria-hidden', 'false');
  refreshCartDrawer();
}

function closeCart() {
  document.getElementById('cart-drawer').classList.remove('open');
  document.getElementById('cart-drawer').setAttribute('aria-hidden', 'true');
}

async function refreshCartDrawer() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const body = document.getElementById('cart-drawer-body');
    const footer = document.getElementById('cart-drawer-footer');
    const countEl = document.getElementById('cart-count');

    if (countEl) countEl.textContent = cart.item_count;

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cart-empty">Your bag is empty.</p>';
      footer.style.display = 'none';
      return;
    }

    body.innerHTML = cart.items.map(item => `
      <div class="cart-item">
        <img class="cart-item__image" src="${item.image}" alt="${item.title}">
        <div class="cart-item__info">
          <p class="cart-item__name">${item.product_title}</p>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<p style="font-size:11px;color:var(--muted);margin-bottom:6px">${item.variant_title}</p>` : ''}
          <p class="cart-item__price">${formatMoney(item.price)}</p>
        </div>
        <button class="cart-item__remove" onclick="removeFromCart(${item.variant_id})" aria-label="Remove">×</button>
      </div>
    `).join('');

    document.getElementById('cart-subtotal-amount').textContent = formatMoney(cart.total_price);
    footer.style.display = 'block';
  } catch(e) {
    console.error('Cart refresh failed', e);
  }
}

async function quickAdd(e, variantId, title, price, image) {
  e.preventDefault();
  e.stopPropagation();
  try {
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });
    showToast('Added to bag');
    refreshCartDrawer();
    const countEl = document.getElementById('cart-count');
    if (countEl) countEl.textContent = parseInt(countEl.textContent || '0') + 1;
  } catch(e) {
    showToast('Could not add item');
  }
}

async function removeFromCart(variantId) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 0 }),
  });
  refreshCartDrawer();
}

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

// ── Toast ─────────────────────────────────────────────
function showToast(msg) {
  const t = document.getElementById('toast');
  if (!t) return;
  t.textContent = msg;
  t.classList.add('show');
  setTimeout(() => t.classList.remove('show'), 2800);
}

// ── Email signup ──────────────────────────────────────
function handleEmailSignup(e, form) {
  e.preventDefault();
  const email = form.querySelector('input[type=email]').value;
  if (!email) return;
  // Hook up to Klaviyo, Mailchimp, or Shopify Email here
  showToast('You\'re in! Welcome to ZAVELLE.');
  form.reset();
}

// ── Mobile menu ───────────────────────────────────────
function toggleMobileMenu() {
  // Simple toggle — expand nav on mobile
  const nav = document.querySelector('.site-nav');
  if (!nav) return;
  nav.style.display = nav.style.display === 'flex' ? 'none' : 'flex';
  nav.style.flexDirection = 'column';
  nav.style.position = 'absolute';
  nav.style.top = '70px';
  nav.style.left = '0';
  nav.style.right = '0';
  nav.style.background = 'rgba(14,13,11,.98)';
  nav.style.padding = '20px 24px';
  nav.style.borderBottom = '1px solid rgba(196,149,133,.15)';
  nav.style.gap = '16px';
}

// ── Close cart on Escape ──────────────────────────────
document.addEventListener('keydown', e => {
  if (e.key === 'Escape') closeCart();
});

// ── Refresh cart count on load ────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const el = document.getElementById('cart-count');
      if (el) el.textContent = cart.item_count;
    });
});
